module.exports = __webpack_public_path__ + "static/img/conversorI2c-1.7fa4ece.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/conversorI2c-1.svg
// module id = LEyG
// module chunks = 0